import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-24 md:pt-28">
        <div className="w-full px-4 md:px-8 lg:px-12 max-w-3xl mx-auto pb-20">
          <nav className="flex items-center gap-2 text-sm mb-8">
            <a href="/" className="text-warm-500 hover:text-brand-600 transition-colors">Home</a>
            <i className="ri-arrow-right-s-line text-warm-400 text-xs" />
            <span className="text-warm-700">Terms of Service</span>
          </nav>

          <h1 className="font-heading text-3xl md:text-4xl font-bold text-warm-900 mb-6">
            Terms of Service
          </h1>

          <div className="text-sm md:text-base text-warm-600 leading-relaxed space-y-4">
            <p><strong>Last Updated:</strong> 2026-08-26</p>

            <h2 className="font-heading text-xl font-semibold text-warm-900 mt-6">1. Acceptance of Terms</h2>
            <p>By accessing and using CSSSpreadsheetBR, you agree to these Terms of Service. If you do not agree, please discontinue use of this website.</p>

            <h2 className="font-heading text-xl font-semibold text-warm-900 mt-6">2. Independent Resource</h2>
            <p>CSSSpreadsheetBR is an independent informational website. We are not affiliated with, endorsed by, or sponsored by CSSBuy. All content is provided for research and informational purposes only.</p>

            <h2 className="font-heading text-xl font-semibold text-warm-900 mt-6">3. No Guarantees</h2>
            <p>We do not guarantee the accuracy, completeness, or timeliness of any information on this website. Product links, prices, shipping costs, and coupon codes may change without notice. Always verify information directly on the official platforms before making purchases.</p>

            <h2 className="font-heading text-xl font-semibold text-warm-900 mt-6">4. External Links</h2>
            <p>This website contains links to external websites. We are not responsible for the content, accuracy, or practices of any third-party websites. Use external links at your own discretion.</p>

            <h2 className="font-heading text-xl font-semibold text-warm-900 mt-6">5. Limitation of Liability</h2>
            <p>CSSSpreadsheetBR shall not be liable for any direct, indirect, incidental, or consequential damages arising from the use or inability to use this website or its content.</p>

            <h2 className="font-heading text-xl font-semibold text-warm-900 mt-6">6. Changes to Terms</h2>
            <p>We may modify these terms at any time. Continued use of the website after changes constitutes acceptance of the updated terms.</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}